// extracted by css-extract-rspack-plugin
export default {"phoneContainer":"phone-container--s57AhgbnReMO12TX","icon":"icon--ZjsxbZVaxnwATt6q"};